import { z } from "zod";

import { JavaCurrencyValue } from "../../../utils/currency";

const JavaCurrencyValueSchema: z.ZodType<JavaCurrencyValue> = z.object({
  currency: z.string(),
  amount: z.string(),
  decimalPoints: z.string(),
  displayAmount: z.string(),
});

const PropertyEntrySchema = z.object({
  propertyName: z.string(),
  amount: JavaCurrencyValueSchema,
});

const Top5PropertiesTransactionEntrySchema = z.object({
  roundedDownTransactionDate: z.string().optional(),
  quarter: z.string(),
  month: z.string(),
  year: z.string(),
  properties: z.array(PropertyEntrySchema),
});

export const Top5PropertiesTransactionsResultSchema = z.object({
  top5PropertiesTransactions: z.object({
    transactions: z.array(Top5PropertiesTransactionEntrySchema),
  }),
});

export type Top5PropertiesTransactionsResult = z.infer<
  typeof Top5PropertiesTransactionsResultSchema
>;
